import { render, staticRenderFns } from "./AdminCarModels.vue?vue&type=template&id=3fed72e3&scoped=true"
import script from "./AdminCarModels.vue?vue&type=script&lang=js"
export * from "./AdminCarModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed72e3",
  null
  
)

export default component.exports